window._ = require('lodash');
import createAuthRefreshInterceptor from 'axios-auth-refresh'

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

const getCSRFToken = () => {
    let token = document.head.querySelector(
        'meta[name="csrf-token"]'
    );
    return token?.content
}

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;

const token = getCSRFToken()

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token
} else {
    console.error(
        'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token'
    )
}
// The following code adds an interceptor that renews the CSRF token whenever
// the app recieves a token mismatch error
const refreshCSRFToken = () => {
    return new Promise((resolve, reject) => {
        console.log('Token expired, fetching a new one')
        window.axios
            .get('/admin/login')
            .then(({ data }) => {
                const wrapper = document.createElement('div')
                wrapper.innerHTML = data
                return wrapper
                    .querySelector('meta[name=csrf-token]')
                    ?.getAttribute('content')
            })
            .then((token) => {
                document
                    .querySelector('meta[name=csrf-token]')
                    ?.setAttribute('content', token || '')
                resolve()
            })
            .catch(() => reject())
    })
}

createAuthRefreshInterceptor(axios, refreshCSRFToken, {
    statusCodes: [419],
})

// Using a second interceptor to inject the newly fetched CSRF token to all requests
window.axios.interceptors.request.use((request) => {
    request.headers['X-CSRF-TOKEN'] = getCSRFToken()
    return request
})
